import { Message } from "@/i18n/Message";
type AtoLogoProps = {
  /** Icon size in px. Wordmark size scales proportionally. */
  size?: number;
  className?: string;
};

/**
 * Ato brand mark used in the gallery header. Renders the no-border icon
 * (PNG for broad compatibility and crisp rendering) alongside the "ato"
 * wordmark, sized/positioned to sit flush in the header brand slot.
 */
export default function AtoLogo({ size = 28, className }: AtoLogoProps) {
  return (
    <span className={className} style={{ display: "inline-flex", alignItems: "center", gap: 9 }}>
      <img
        src="/icons/ato-icon-no-border.png"
        alt=""
        width={size}
        height={size}
        style={{
          width: size,
          height: size,
          objectFit: "contain",
          display: "block",
        }}
      />
      <span
        className="ato-logo-wordmark"
        style={{
          fontFamily: "var(--font-brand)",
          fontSize: Math.round(size * 0.86),
          fontWeight: 600,
          letterSpacing: "-0.02em",
          lineHeight: 1,
          transform: "translate(-6px, -1px)",
        }}
      ><Message message={"ato"} /></span>
    </span>
  );
}
